import TopHeadScreen from "../../component/layout/tophead";
import SidebarScreen from "../../component/layout/sidebar";
import AuthFooterScreen from "../../component/layout/authfooter";
import JobDetails from "../../common/job-details";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import AgentSidebarScreen from "../../component/layout/agent-sidebar";
import AgentTopHeadScreen from "../../component/layout/agent-header";
import { useEffect, useState } from "react";
import {
  appliedDetails,
  resumelistForAgent,
} from "../../service/apis/auth.api";
import { showError } from "../../utils/Common";
import {
  addResumeToList,
  clearAllResumes,
  ResumeDetails,
} from "../../store/resume.store";

const JobsDetailsScreen = () => {
  const { state } = useLocation();
  const { user } = useSelector((state: RootState) => state.authSlice);
  const [isApplied, setIsApplied] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    if (user && user?.role === "jobseeker") {
      fetchAppliedDetails();
    } else if (user && user?.role === "localagents") {
      getResumeListForAgent(state?.jobId);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state?.jobId]);
  const fetchAppliedDetails = async () => {
    try {
      // setLoading(true);
      const response = await appliedDetails(state?.jobId);

      setIsApplied(response?.detailApplication?.[0]?.status);
    } catch (err: any) {
      showError(err?.message);
    } finally {
      // setLoading(false);
    }
  };

  const getResumeListForAgent = async (jobId: string = "") => {
    let payload = {
      jid: jobId,
    };
    try {
      // setLoading(true);
      const response = await resumelistForAgent(payload);
      // console.log(response, "response resume list");
      const updatedDetails = {
        resumeDetails:
          response?.data?.filteredResumes &&
          response?.data?.filteredResumes?.map((resumeDetail: any) => ({
            name: resumeDetail?.resume?.resumeData?.name,
            bio: resumeDetail?.resume?.resumeData?.bio,
            email: resumeDetail?.resume?.resumeData?.email,
            explevel: resumeDetail?.resume?.resumeData?.explevel,
            contact: resumeDetail?.resume?.resumeData?.contact,
            experiences: resumeDetail?.resume?.resumeData?.experiences,
            skills: resumeDetail?.resume?.resumeData?.skills,
            achievements: resumeDetail?.resume?.resumeData?.achievements,
            educations: resumeDetail?.resume?.resumeData?.educations,
            resumeLink: resumeDetail?.resume?.resumeLink,
            _id: resumeDetail?._id,
          })),
      };
      dispatch(clearAllResumes());
      updatedDetails.resumeDetails.forEach((resumeDetail: ResumeDetails) => {
        dispatch(addResumeToList(resumeDetail));
      });
    } catch (err: any) {
      showError(err?.message);
    } finally {
      // setLoading(false);
    }
  };

  return (
    <>
      <div className="main">
        <section className="profileJobDetails-area">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-2 sidebar  position-relative p-0">
                {user && user?.role === "jobseeker" && <SidebarScreen />}
                {user && user?.role === "localagents" && <AgentSidebarScreen />}
              </div>
              <div className="col-lg-10 rightcontent p-0">
                {user && user?.role === "jobseeker" && <TopHeadScreen />}
                {user && user?.role === "localagents" && <AgentTopHeadScreen />}
                <JobDetails
                  jobId={state?.jobId}
                  applyStatus={isApplied || state?.status}
                  // isApplied={isApplied}
                />
              </div>
            </div>
          </div>
        </section>
      </div>
      <AuthFooterScreen />
    </>
  );
};
export default JobsDetailsScreen;
